import React, { useState, useEffect } from "react";
import { BaseModal } from "./BaseModal";
import { TextArea } from "./InputGroup";
import { Checklist } from "./Checklist";

interface CallModalProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  leftOffset?: number;
  onCallAdded: (activity: { icon: string; time: string; text: string }) => void;
}

type CallStatus = "idle" | "calling" | "connected";
type CallMethod = "self" | "relative";

const relativeItems = [
  {
    title: "Petra Mustermann",
    detail: "Mutter - Primärer Kontakt",
  },
  {
    title: "Hans Mustermann",
    detail: "Bruder - Sekundärer Kontakt",
  },
];

const CallModal: React.FC<CallModalProps> = ({
  open,
  onClose,
  onOpen,
  leftOffset = 50,
  onCallAdded,
}) => {
  const [callStatus, setCallStatus] = useState<CallStatus>("idle");
  const [note, setNote] = useState("");
  const [error, setError] = useState("");
  const [checklistItems, setChecklistItems] = useState<string[]>([]);
  const [callMethod, setCallMethod] = useState<CallMethod>("self");
  const [selectedRelative, setSelectedRelative] = useState<string>("");

  useEffect(() => {
    if (open) {
      setCallStatus("idle");
      setNote("");
      setError("");
      setCallMethod("self");
      setSelectedRelative("");
    }
  }, [open]);

  const handleStartCall = () => {
    if (callMethod === "relative" && selectedRelative === "") {
      alert("Bitte wählen Sie einen Angehörigen aus!");
      return;
    }
    setCallStatus("calling");
    const connectionTimer = setTimeout(() => {
      setCallStatus("connected");
    }, 3000);

    return () => clearTimeout(connectionTimer);
  };

  const handleEndCall = () => {
    if (callStatus !== "connected") {
      setError("Der Anruf muss erst verbunden sein.");
      return;
    }

    const contactName =
      callMethod === "self" ? "Max Mustermann" : selectedRelative;

    const newActivity = {
      icon: "fa-solid fa-phone",
      text: `Anruf bei ${contactName} beendet. Notizen: ${note || "keine Notizen"}`,
      time: new Date().toLocaleTimeString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),
      detail: new Date().toLocaleTimeString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }),

    };

    onCallAdded(newActivity);
    onClose();
  };

  const renderCallStatus = () => {
    const contactName =
      callMethod === "self"
        ? "Max Mustermann"
        : selectedRelative || "den ausgewählten Angehörigen";
    switch (callStatus) {
      case "idle":
        return (
          <div className="call-header">
            <h2>Rufen Sie {contactName} jetzt an:</h2>
            <button onClick={handleStartCall} className="primary-button">
              Jetzt anrufen
            </button>
          </div>
        );
      case "calling":
        return (
          <div className="status-indicator">
            <div className="spinner" />
            <span>Aufbau des Anrufs...</span>
          </div>
        );
      case "connected":
        return (
          <div className="status-indicator success">
            <div className="status-icon" />
            <span>Verbunden</span>
          </div>
        );
    }
  };

  return (
    <BaseModal
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      leftOffset={leftOffset}
      headerText="Klient anrufen"
      className="call-modal"
    >
      <div className="call-content">

        <div className="input-group">
          <label>Wen möchten Sie anrufen?</label>
          <select
            value={selectedRelative}
            onChange={(e) => setSelectedRelative(e.target.value)}
          >
            <option value="">Max Mustermann - Patient selbst</option>
            {relativeItems.map((relative, idx) => (
              <option key={idx} value={relative.title}>
                {relative.title} - {relative.detail}
              </option>
            ))}
          </select>
        </div>



        {renderCallStatus()}

        <section className="conversation-starter">
          <div style={{
            display: "flex", // space between the icon and text
            alignItems: "center",
            justifyContent: "space-between",

          }}>
            <h3>Gesprächseinstieg</h3>
            <i className="fa-solid fa-edit" />
          </div>
          <p style={{ color: "#333" }}>
            Guten Tag Herr Mustermann, vielen Dank für Ihr Interesse an unserem Pflegedienst.
          Gerne unterstützen wir Sie und Ihre Angehörigen. Lassen Sie uns gemeinsam
          besprechen, wie wir Ihre individuellen Bedürfnisse optimal erfüllen können.
        </p>
      </section>


      <TextArea
        label="Notizen:"
        value={note}
        onChange={setNote}
        placeholder="Während des Anrufs mitschreiben..."
        error={error}
      />

      {callStatus === "connected" && (
        <div className="modal-actions">
          <button onClick={handleEndCall} className="danger-button">
            Anruf beenden
          </button>
        </div>
      )}


      <div style={{
        display: "flex", // space between the icon and text
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "-10px",

      }}>
        <h3>Checkliste</h3>
        <i className="fa-solid fa-edit" />
      </div>




      <Checklist
        items={[
          "Bedarf vorhanden",
          "Bereitschaft vorhanden",
          "Termin vereinbart",
        ]}
        onUpdate={setChecklistItems}
      />
    </div>
    </BaseModal >
  );
};

export default CallModal;
